import store from '@/app/app-state';
import { ref } from '@vue/composition-api';
import { CLIENT_TYPE_STORE_MODULE_NAME } from '../clientTypesStoreModule';

export function useClientTypeUpdate() {
  const isOpen = ref(false);
  const clientType = ref('');
  const formUpdateRef = ref(null);

  const rules = {
    title: [{ required: true, message: 'Укажите название типа', trigger: 'change' }],
  };

  let updateDialogController = null;

  const open = (p) => {
    clientType.value = p;
    let resolve;
    let reject;
    const updateDialogPromise = new Promise((ok, fail) => {
      resolve = ok;
      reject = fail;
    });
    updateDialogController = { resolve, reject };
    isOpen.value = true;
    return updateDialogPromise;
  };

  const saveClientType = () => {
    try {
      const { id, title } = clientType.value;
      formUpdateRef.value.validate((valid) => {
        if (valid) {
          store.dispatch(`${CLIENT_TYPE_STORE_MODULE_NAME}/updateClientTypes`, {
            id,
            payload: { title },
          });
          updateDialogController.resolve(true);
          isOpen.value = false;
          return;
        }
        return false;
      });
    } catch (e) {
      updateDialogController.reject(false);
      isOpen.value = false;
    }
  };

  return {
    isOpen,
    open,
    clientType,
    saveClientType,
    rules,
    formUpdateRef,
  };
}
